import React from 'react';
import { createRoot } from 'react-dom/client';

import { BrowserRouter } from 'react-router-dom';
import PromoCheckoutApp from './components/PromoCheckoutApp';


export default function initializeApp(config) {
    const root = createRoot(document.getElementById('application'));
    root.render(
        <BrowserRouter>
            <PromoCheckoutApp config={config} />
        </BrowserRouter>,
    );
}
